// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hcU2","footer":"styles_footer__15Hp5","passCodeTooltip":"styles_passCodeTooltip__2L7ZB"};